/**
 * Split a string by delimiters, trimming each value and filtering empties.
 * @param val - The input string to split
 * @param splitOnSpaces - If true, splits on commas AND whitespace. If false, only commas.
 *                        Default: true (for backward compatibility with ID fields).
 *                        Use false for text fields like "Name Contains" where phrases may have spaces.
 */
export const splitByDelimiters = (val: string, splitOnSpaces = true): string[] =>
  val.split(splitOnSpaces ? /[\s,]+/ : /,/).map((s) => s.trim()).filter(Boolean);

/** Trim a string and collapse every inner run of whitespace to a single space. */
export const normalizeWhitespace = (val: string): string => val.replace(/\s+/g, ' ').trim();
